export default __webpack_public_path__ + "static/webhooks-failed-reason-60ec06a076489911200a9d7f4b237084.png";